import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
    selector: '[appInputRestriction]',
    standalone: false

})
export class InputRestrictionDirective {
    inputElement: ElementRef;

    regex = new RegExp('[ a-zA-Z0-9æøåÆØÅ,./()-]', 'g');

    constructor(el: ElementRef) {
        this.inputElement = el;
    }

    @HostListener('keypress', ['$event']) onKeyPress(event) {
        // Regex will fail every second test if this is not set.
        this.regex.lastIndex = null;
        const e = event as KeyboardEvent;
        if (e.key === 'Tab' || e.key === 'TAB') {
            return;
        }

        const ch = String.fromCharCode(e.keyCode);

        if (this.regex.test(ch)) {
            return;
        }
        e.preventDefault();
    }

    @HostListener('paste', ['$event']) onPaste(event) {
        // Regex will fail every second test if this is not set.
        this.regex.lastIndex = null;

        const e = event as ClipboardEvent;
        const pasteData = e.clipboardData.getData('text/plain');

        if ((pasteData.match(this.regex) || []).length == pasteData.length) {
            return;
        } else {
            e.preventDefault();
            let resultString = '';
            pasteData.split('').forEach((item) => {
                this.regex.lastIndex = null;
                if (this.regex.test(item)) {
                    resultString += item;
                }
            });
            this.inputElement.nativeElement.value = resultString;
        }
    }
}
